import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterModalComponent } from './filter-modal/filter-modal.component';
import { SharedModule } from '../shared.module';
import { TableModule } from '../table/table.module';
import { DmCustomFiltersComponent } from './dm-custom-filters/dm-custom-filters.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [FilterModalComponent, DmCustomFiltersComponent],
  imports: [
    CommonModule,
    SharedModule,
    TableModule,
    FormsModule,
    NgSelectModule
  ],
  exports: [FilterModalComponent, DmCustomFiltersComponent]
})
export class SharedFilterModalModule { }
